import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IGetReservationRes } from "types/reservation"

import reservationsService from "api/reservationsService"

const useGetReservation = (reservationId: number, enabled?: boolean) => {
  return useQuery("reservation", async () => {
    try {
      const res: AxiosResponse<IGetReservationRes> = await reservationsService.getReservation(reservationId)

      return res.data
    }  catch (err: any) {
      return err.response
    }
  }, { enabled, refetchOnWindowFocus: false })
}

export default useGetReservation